import _regenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ElInputTag } from 'el-input-tag';
import vueJsonEditor from 'vue-json-editor';
import { createVideoArchive, updateVideoArchive } from '@/api/videoArchive';
import validator from 'validator';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "archive", void 0);
    _defineProperty(_this, "title", void 0);
    _defineProperty(_this, "visible", void 0);
    _defineProperty(_this, "action", void 0);
    _defineProperty(_this, "formRules", {
      category: [{
        required: true,
        message: 'category is required',
        trigger: 'change'
      }],
      title: [{
        required: true,
        message: 'title is required',
        trigger: 'blur'
      }],
      video_url: [{
        required: true,
        message: 'Video Url is required',
        validator: _this.validateUrl,
        trigger: 'blur'
      }],
      image_url: [{
        required: true,
        message: 'Image Url required',
        validator: _this.validateUrl,
        trigger: 'blur'
      }]
    });
    _defineProperty(_this, "archiveTypes", [{
      label: 'THERAPIST_LIVE',
      key: 'THERAPIST_LIVE'
    }, {
      label: 'HOME_TRAINING',
      key: 'HOME_TRAINING'
    }]);
    _defineProperty(_this, "formData", Object.assign({}, _this.archive));
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {}
  }, {
    key: "handleOpen",
    value: function handleOpen() {
      var form = this.$refs['dataForm'];
      if (form) form.resetFields();
      var formData = Object.assign({
        tags: []
      }, this.archive);
      this.formData = formData;
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.$emit('update:visible', false);
    }
  }, {
    key: "initReqData",
    value: function initReqData() {
      var reqData = Object.assign({}, this.formData);
      return reqData;
    }
  }, {
    key: "validateUrl",
    value: function validateUrl(rule, value, callback) {
      if (validator.isEmpty(value) || !validator.isURL(value)) {
        callback(new Error('URL is not valid'));
      } else {
        callback();
      }
    }
  }, {
    key: "createData",
    value: function createData() {
      var _this2 = this;
      this.$refs['dataForm'].validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(valid) {
          var data;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!valid) {
                  _context.n = 2;
                  break;
                }
                _context.n = 1;
                return createVideoArchive(_this2.initReqData());
              case 1:
                data = _context.v;
                _this2.$notify({
                  title: 'Created',
                  message: 'Created Successfully',
                  type: 'success',
                  duration: 2000
                });
                _this2.handleClose();
              case 2:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "updateData",
    value: function updateData() {
      var _this3 = this;
      this.$refs['dataForm'].validate(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(valid) {
          var data;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                if (!valid) {
                  _context2.n = 2;
                  break;
                }
                _context2.n = 1;
                return updateVideoArchive(_this3.initReqData());
              case 1:
                data = _context2.v;
                _this3.$notify({
                  title: 'Updated',
                  message: 'Updated Successfully',
                  type: 'success',
                  duration: 2000
                });
                _this3.handleClose();
              case 2:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }]);
}(Vue);
__decorate([Prop({
  required: false
})], default_1.prototype, "archive", void 0);
__decorate([Prop({
  required: false
})], default_1.prototype, "title", void 0);
__decorate([Prop({
  required: false
})], default_1.prototype, "visible", void 0);
__decorate([Prop({
  required: false
})], default_1.prototype, "action", void 0);
default_1 = __decorate([Component({
  name: 'EditorArchive',
  components: {
    ElInputTag: ElInputTag,
    vueJsonEditor: vueJsonEditor
  }
})], default_1);
export default default_1;